module.exports = __webpack_public_path__ + "img/u13.1097476e.jpg";